export const formatText = (text: string) => text.toUpperCase().trim();
